import styled, { css } from 'styled-components';

import { ButtonSize, ButtonVariant, buttonBorder } from '../Button';

export type IconBadgeProps = {
  size?: ButtonSize;
  variant?: ButtonVariant;
  error?: boolean;
};

const IconBadge = styled.i<IconBadgeProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  transition: 0.16s background-color linear;

  & svg {
    flex-shrink: 0;
  }

  ${({ theme, variant, error }) => {
    if (error) {
      return css`
        background-color: ${theme.mosaiq.colors.softPeach};
        svg {
          color: ${theme.mosaiq.colors.error};
        }
      `;
    }

    if (variant === 'secondary') {
      return css`
        background-color: 'transparent';
        svg {
          color: ${theme.mosaiq.colors.passive};
        }
      `;
    }

    return css`
      background-color: ${theme.mosaiq.colors.black};
      svg {
        color: ${theme.mosaiq.colors.grey20};
      }
    `;
  }}

  ${buttonBorder}

  ${({ size = 'regular', theme }) => {
    switch (size) {
      case 'large':
        return css`
          padding: 0px ${theme.mosaiq.spacing(2)}px;
          min-height: ${theme.mosaiq.spacing(5)}px;
          max-height: ${theme.mosaiq.spacing(5)}px;
        `;

      case 'small':
        return css`
          padding: 0px ${theme.mosaiq.spacing(1)}px;
          min-height: ${theme.mosaiq.spacing(3)}px;
          max-height: ${theme.mosaiq.spacing(3)}px;
        `;

      default:
        return css`
          padding: 0px ${theme.mosaiq.spacing(1.25)}px;
          min-height: ${theme.mosaiq.spacing(4)}px;
          max-height: ${theme.mosaiq.spacing(4)}px;
        `;
    }
  }}
`;

export default IconBadge;
